var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8687 13.5L7.85 10.4813L8.65625 9.675L10.8687 11.8875L15.4437 7.3125L16.25 8.11875L10.8687 13.5ZM1.625 11.775C1.3125 11.775 1.04688 11.6656 0.828125 11.4469C0.609375 11.2281 0.5 10.9625 0.5 10.65V1.125C0.5 0.8125 0.609375 0.546875 0.828125 0.328125C1.04688 0.109375 1.3125 0 1.625 0H14.3187C14.6312 0 14.8969 0.109375 15.1156 0.328125C15.3344 0.546875 15.4437 0.8125 15.4437 1.125V5.7L10.8312 10.3125L8.65625 8.1375L6.275 10.5187L7.55 11.775H1.625ZM7.9625 6.24375L14.3187 2.175L14.225 1.125L7.9625 5.11875L1.7 1.125L1.625 2.175L7.9625 6.24375Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationChecked);
export default __webpack_public_path__ + "static/media/notificationChecked.8197a1008174d005e7b4c265f3f56e2c.svg";
export { ForwardRef as ReactComponent };